export const TimeValidator = (value, component) => {

	var arrTime = value.split(':');
	
	//console.log(arrTime);
	
	if(parseInt(arrTime[0]) > 24) { return false; } 
	if(parseInt(arrTime[1]) > 59) { return false; } 

	return true;

}



// WEBPACK FOOTER //
// ./resources/assets/js/validators/time-validator.js